import { render, staticRenderFns } from "./CertificatesModal.vue?vue&type=template&id=181ef13d&scoped=true&"
import script from "./CertificatesModal.vue?vue&type=script&lang=js&"
export * from "./CertificatesModal.vue?vue&type=script&lang=js&"
import style0 from "./CertificatesModal.vue?vue&type=style&index=0&id=181ef13d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181ef13d",
  null
  
)

export default component.exports